module.exports = __webpack_public_path__ + "static/media/logo-pet.29da5a49.svg";